import React, { useState, useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import classnames from 'classnames'
import "whatwg-fetch"

import TInputForm from "../../../common/TInputForm"
import TTextareaForm from "../../../common/TTextareaForm"
import BlogLogoForm from "../BlogLogoForm"
import BlogIconForm from "../BlogIconForm"
import BlogFaviconForm from "./BlogFaviconForm"

import * as SaveStatus from '../../../../constants/SaveStatus'
import { receiveInfo } from '../../../../actions/setting/blog'
import { jsonResponseHandler } from "../../../../utils/FetchHelper"
import TSubmitButtonForm from "../../../common/TSubmitButtonForm";
import {addPrefix} from "../../../../utils/UriUtil";

const MAX_BLOG_TITLE_LENGTH = 40;

export default function BlogInfoForm() {
  const info = useSelector(state => state.setting.blog.info)
  const dispatch = useDispatch()

  const [saveStatus, setSaveStatus] = useState(SaveStatus.READY)
  const [logoUrl, setLogoUrl] = useState(info.logoUrl)
  const [iconUrl, setIconUrl] = useState(info.iconUrl)
  const [faviconUrl, setFaviconUrl] = useState(info.faviconUrl)
  const [userTitle, setUserTitle] = useState(info.userTitle)
  const [description, setDescription] = useState(info.description)
  const [name, setName] = useState(info.name)
  const [title, setTitle] = useState(info.title)
  /* 블로그명 길이 제한 패치 전 블로그명이 이미 40자를 초과했던 블로그들에 대한 플래그 */
  const [isBlogTitleLengthValid] = useState(info.title.length <= MAX_BLOG_TITLE_LENGTH)

  useEffect(() => {
    if (!isBlogTitleLengthValid) {
      truncateBlogTitle()
      alert(`블로그 이름을 ${ MAX_BLOG_TITLE_LENGTH }글자 이하로 설정해주세요.`)
    }
  }, [])

  /**
   * 블로그 명이 40자를 초과하는 블로그는 블로그명을 truncate 후 표기한다.
   */
  function truncateBlogTitle() {
    setTitle(title.substring(0, MAX_BLOG_TITLE_LENGTH))
  }

  function handleReceiveInfo(name, info) {
    dispatch(receiveInfo(info))
    if (TistoryGnb && TistoryGnb.updateBlogTitle) {
      TistoryGnb.updateBlogTitle(name, info.title)
    }
  }

  function handleDeleteLogo() {
    if(confirm('이미지를 삭제하시겠습니까?')) {
      setLogoUrl(null)
    }
  }

  function handleDeleteIcon() {
    if(confirm('아이콘을 삭제하시겠습니까?')){
      setIconUrl(null)
    }
  }

  function handleDeleteFavicon() {
    if(confirm('파비콘을 삭제하시겠습니까?')) {
      setFaviconUrl(null)
    }
  }

  function trimStr(str){
     return str === null ? "" : str.trim();
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (saveStatus === SaveStatus.DOING) {
      return
    }

    let editedInfo = {
      logoUrl: logoUrl,
      title: trimStr(title),
      userTitle: trimStr(userTitle),
      description: description,
      iconUrl: iconUrl,
      faviconUrl: faviconUrl,
      name : name,
    };

    setSaveStatus(SaveStatus.DOING)
    fetch(addPrefix("/manage/setting/blog/info.json"), {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(editedInfo)
    })
      .then(jsonResponseHandler(dispatch))
      .then(() => {
        setSaveStatus(SaveStatus.DONE)
        setTitle(editedInfo.title)
        setUserTitle(editedInfo.userTitle)
        setName(editedInfo.name)
        handleReceiveInfo(name, editedInfo)
      })
      .catch(e => {
        console.error(e)
        setSaveStatus(saveStatus)
      })
  }

  function isChangedAndValid() {
    let changed = logoUrl !== info.logoUrl
      || title !== info.title
      || description !== info.description
      || iconUrl !== info.iconUrl
      || faviconUrl !== info.faviconUrl
      || userTitle !== info.userTitle
    let valid = title !== ''

    return changed && valid
  }

  let needSave = isChangedAndValid()
  let status = saveStatus
  if (saveStatus !== SaveStatus.DOING && needSave) {
    status = SaveStatus.CAN_SUBMIT
  }

  return (
    <form className="wrap_set" onSubmit={handleSubmit}>

      <BlogLogoForm logo={logoUrl} onChange={setLogoUrl} onDelete={handleDeleteLogo} />

      <fieldset className="fld_name">
        <legend className="screen_out">블로그 이름 설정</legend>
        <label className="lab_tf">
          <strong className="tit_set">블로그 이름</strong>
          <TInputForm type="text" className="tf_blog" value={title} onChange={setTitle} maxlength={MAX_BLOG_TITLE_LENGTH.toString()} />
        </label>
        <p className={classnames("txt_required hide", { "hide": title !== '' })}>
          블로그 이름을 입력해주세요
        </p>
        <div className="lab_tf">
          <strong className="tit_set">닉네임 수식어 <a href="http://notice.tistory.com/1771" className="info_sub" target="_blank">자세히 보기</a></strong>
          <TInputForm type="text" className="tf_blog" value={userTitle} onChange={setUserTitle} />
        </div>
        <div className="lab_tf">
          <strong className="tit_set">블로그 설명</strong>
          <TTextareaForm className="tf_blog" defaultValue={description} onChange={setDescription} />
        </div>
      </fieldset>

      <BlogIconForm icon={iconUrl} onChange={setIconUrl} onDelete={handleDeleteIcon} />

      <BlogFaviconForm favicon={faviconUrl} onChange={setFaviconUrl} onDelete={handleDeleteFavicon} />

      <fieldset>
        <legend className="screen_out">저장 버튼</legend>
        <TSubmitButtonForm type="submit" status={status} />
      </fieldset>
    </form>
  )
}
